// extracted by mini-css-extract-plugin
export var bottomSection = "WhatCanExpect-module--bottomSection--15AR3";
export var bottomText = "WhatCanExpect-module--bottomText--kEfJ9";
export var cardsSection = "WhatCanExpect-module--cardsSection--yhJJX";
export var headerSection = "WhatCanExpect-module--headerSection--4bNqE";
export var title = "WhatCanExpect-module--title--bBIf4";
export var whatCanExpectWrapper = "WhatCanExpect-module--whatCanExpectWrapper--Wo4DO";